import api from './apiClient';
import {
  Invoice,
  InvoiceCreate,
  InvoiceUpdate,
  InvoiceListResponse,
  Payment,
  PaymentCreate,
  ServiceCatalog,
  ServiceCatalogCreate,
  TaxRate,
  InvoiceStats,
  SalesReportResponse,
  PaymentsReportResponse,
} from '../types';

export const billingService = {
  createInvoice: async (data: InvoiceCreate): Promise<Invoice> => {
    const response = await api.post('/billing/invoices', data);
    return response.data;
  },

  getInvoices: async (params?: {
    page?: number;
    size?: number;
    status?: string;
    date_from?: string;
    date_to?: string;
  }): Promise<InvoiceListResponse> => {
    const response = await api.get('/billing/invoices', { params });
    return response.data;
  },

  getInvoice: async (id: number): Promise<Invoice> => {
    const response = await api.get(`/billing/invoices/${id}`);
    return response.data;
  },

  updateInvoice: async (id: number, data: InvoiceUpdate): Promise<Invoice> => {
    const response = await api.put(`/billing/invoices/${id}`, data);
    return response.data;
  },

  addPayment: async (invoiceId: number, data: PaymentCreate): Promise<Payment> => {
    const response = await api.post(`/billing/invoices/${invoiceId}/payments`, data);
    return response.data;
  },

  getInvoiceStats: async (params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<InvoiceStats> => {
    const response = await api.get('/billing/invoices/stats', { params });
    return response.data;
  },

  createService: async (data: ServiceCatalogCreate): Promise<ServiceCatalog> => {
    const response = await api.post('/billing/services', data);
    return response.data;
  },

  getServices: async (params?: {
    clinic_id?: number;
    category?: string;
    is_active?: boolean;
  }): Promise<ServiceCatalog[]> => {
    const response = await api.get('/billing/services', { params });
    return response.data;
  },

  updateService: async (id: number, data: Partial<ServiceCatalogCreate>): Promise<ServiceCatalog> => {
    const response = await api.put(`/billing/services/${id}`, data);
    return response.data;
  },

  deleteService: async (id: number): Promise<void> => {
    await api.delete(`/billing/services/${id}`);
  },

  createTaxRate: async (data: any): Promise<TaxRate> => {
    const response = await api.post('/billing/tax-rates', data);
    return response.data;
  },

  getTaxRates: async (params?: {
    clinic_id?: number;
    is_active?: boolean;
  }): Promise<TaxRate[]> => {
    const response = await api.get('/billing/tax-rates', { params });
    return response.data;
  },

  updateTaxRate: async (id: number, data: any): Promise<TaxRate> => {
    const response = await api.put(`/billing/tax-rates/${id}`, data);
    return response.data;
  },

  deleteTaxRate: async (id: number): Promise<void> => {
    await api.delete(`/billing/tax-rates/${id}`);
  },

  getSalesReport: async (params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<SalesReportResponse> => {
    const response = await api.get('/billing/reports/sales', { params });
    return response.data;
  },

  getPaymentsReport: async (params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<PaymentsReportResponse> => {
    const response = await api.get('/billing/reports/payments', { params });
    return response.data;
  },
};








